/**
 * @owner @Appboy/growth-engineering
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { MilestoneChecklistSettingsApiResponse } from "./types";

export const getMilestoneChecklistSettings = reactQueryFetcherAdapter(
  "/milestone_checklist_settings",
  async (signal): Promise<MilestoneChecklistSettingsApiResponse> => {
    return await fetch("/milestone_checklist_settings", "GET", undefined, { signal });
  }
);
